import { observable_component } from 'common/util/ComponentDecorator';

@observable_component
export default class jsContentDecorator {
	static classname = 'js-content-decorator';

	constructor($content) {
		this.$content = $content;

		this.init();
	}

	init() {
		this.$content.addClass('info');
		this.$content.find('a').addClass('link');
	}
}
